import React from 'react';
import styled from 'styled-components';

import CodengoTitleImg from '../../../images/examCentersReviewHeaders/title-codengo.inline.svg';
import CodengoTitleImgMobile from '../../../images/examCentersReviewHeaders/title-codengo-mobile.inline.svg';
import { isMobile } from '../../../constants';
import media from '../../../utils/mediaQueries';

const CodengoTitleWrap = styled.div`
  position: absolute;
  top: 81px;
  left: 50%;
  transform: translateX(-50%);
  
  ${media.mobile`
    top: 98px
  `}
`;

const CodengoTitle = () => (
  <CodengoTitleWrap>
    {isMobile ? <CodengoTitleImgMobile /> : <CodengoTitleImg />}
  </CodengoTitleWrap>
);

export { CodengoTitle };
